import { Component, Inject, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwContainerOptions, DwExpressionService, DwFormContextMode, DwLookupInfo, DwMessageSeverity, DwMetaDataFormApi, DwMetaDataFormSectionStateService, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwSectionReadonlyBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken } from '@devwareapps/devware-cap';
import { AcsCodesLookupQueryEntity, AcsTestPortionEntity, AppMetaDataItemNames, AppMetaDataLookups, PlanOfActionEntity, PlanOfActionQuestionResultEntity, PlanOfActionSectionEntity, PlanOfActionSectionTypeAllItems, PlanOfActionSectionTypeEntity, PlanOfActionStatusAllItems } from '../../../../meta-data/app-meta-data.service';
import { AcsCodesStorageItem, AcsCodeStatuses } from '../../models/acs-code-items.model';
import { GenerateQuestionsActionService } from '../../actions/generate-questions-action.service';
import { PlanOfActionGeneratorService } from '../../services/plan-of-action-generator.service';
import { PlanOfActionRepositoryService } from '../../services/plan-of-action-repository.service';
import { PlanOfActionExecuteVariables } from '../../models/plan-of-action-execute-variables.model';
import { AcsTestPortionResult, PlanOfActionUtilService } from '../../services/plan-of-action-util.service';
import { Subject } from 'rxjs';
import { debounceTime, finalize, take } from 'rxjs/operators';
import { PlanOfActionPdfService } from '../../services/plan-of-action-pdf.service';

@DwComponent({
  key: 'plan-of-action-execute',
  name: 'Plan of Action Execute',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.PlanOfAction
})
@Component({
  selector: 'app-plan-of-action-execute',
  templateUrl: './plan-of-action-execute.component.html',
  styleUrls: ['./plan-of-action-execute.component.scss']
})
export class PlanOfActionExecuteComponent extends DwSectionReadonlyBaseComponent {
  static expandedSections: { [prop: number]: boolean } = {};

  static printCurrentAcsTestPortions: number[];

  formApi: DwMetaDataFormApi;
  planOfAction: PlanOfActionEntity;
  planOfActionSections: PlanOfActionSectionEntity[];

  rootFormGroup: any;
  //sectionTypes: PlanOfActionSectionTypeEntity[];
  sectionIndex: number;
  planOfActionQuestionResults: PlanOfActionQuestionResultEntity[];
  currentSection: PlanOfActionSectionEntity;
  sectionTypes: PlanOfActionSectionTypeEntity[];
  hasPrevious: boolean;
  hasNext: boolean;
  selectedSectionId: number;

  inPrintMode: boolean = false;
  currentTestSections: PlanOfActionSectionEntity[] = [];

  sectionList: DwLookupInfo[] = [];
  acsTestPortions: AcsTestPortionEntity[];

  currentAcsTestPortion: AcsTestPortionResult;
  acsCodeStatuses: AcsCodeStatuses;

  showAllSections: boolean = true;
  showOnlyMissedAcsCodes = false;
  missedAcsCodeToggleOptions = {
    displayStyle: 'blockButtons' as const,
    trueLabel: 'All',
    trueValue: true,
    falseLabel: 'Missed',
    falseValue: false
  };
  returnAfterSave = false;
  get hasAcsCodeSections(): boolean {
    return this.currentTestSections.some(section =>
      section.PlanOfActionSectionTypeId === PlanOfActionSectionTypeAllItems.AreaOfOperation ||
      section.PlanOfActionSectionTypeId === PlanOfActionSectionTypeAllItems.Task);
  }
  showAllSectionsToggle: boolean = true;
  acsTestDetails: AcsTestPortionResult[];
  acsTestPortionContainer: DwContainerOptions;

  acsTestSelectionContainer = {
    useContainerStyling: true,
    //styleName: 'TITLE_ONLY_LINE',
    // expandCollapseStyle: DwExpandCollapseStyle.chevron,
    // expandCollpaseLocation: DwExpandCollapseLocation.left,
    containerAllowCollapse: false,
    //containerCollapseDefault: true,
    // containerHeaderBackgroundColor: this.currentAcsTestPortion.acsTestPortion.HeaderClass,
    // containerHeaderIcon: this.currentAcsTestPortion.acsTestPortion.IconClass,
    showTitle: false,
  }
  exporting: boolean;
  exportingTestPortionId: number;
  printSections: AcsTestPortionResult[];
  printDetails: any;
  printTestDetails: AcsTestPortionResult[];

  constructor(
    dwExpressionService: DwExpressionService,
    private dwMetaDataFormSectionStateService: DwMetaDataFormSectionStateService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private planOfActionRepositoryService: PlanOfActionRepositoryService,
    private generateQuestionsActionService: GenerateQuestionsActionService,
    private planofActionGeneratorService: PlanOfActionGeneratorService,
    private planOfActionUtilService: PlanOfActionUtilService,
    private planOfActionPdfService: PlanOfActionPdfService
  ) {
    super(dwExpressionService, dwMetaDataFormSectionStateService, dwMetaDataFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);

    this.formApi = this.dwMetaDataFormStateService.state.formApi;
  }


  resultsToSave: PlanOfActionQuestionResultEntity[] = [];

  resultsToSaveMap: { [prop: number]: PlanOfActionQuestionResultEntity } = {};

  goToAcsTestPortion(acsPortion: AcsTestPortionResult) {
    this.currentAcsTestPortion = acsPortion;

    this.updateVariables();

    this.setupAcsTestPortion();
  }

  private updateVariables() {
    this.formApi.patchVariableContext<PlanOfActionExecuteVariables>({ ExecutingTest: !!this.currentAcsTestPortion })
  }

  print(acsTestPortion: AcsTestPortionResult) {
    this.exportingTestPortionId = acsTestPortion.acsTestPortion.AcsTestPortionId;
    this.exporting = true;

    this.planOfActionPdfService
      .downloadPlanOfActionPdf(this.planOfAction.PlanOfActionId, [acsTestPortion.acsTestPortion.AcsTestPortionId])
      .pipe(finalize(() => {
        this.exporting = false;
      }))
      .subscribe();
  }

  setupAcsTestPortion() {
    this.currentTestSections = this.currentAcsTestPortion.sections;

    this.sectionIndex = 0;

    this.setupSectionList();

    this.setupCurrentSection();

    this.acsTestPortionContainer = {
      useContainerStyling: true,
      //styleName: 'TITLE_ONLY_LINE',
      // expandCollapseStyle: DwExpandCollapseStyle.chevron,
      // expandCollpaseLocation: DwExpandCollapseLocation.left,
      containerAllowCollapse: false,
      //containerCollapseDefault: true,
      containerHeaderIcon: this.currentAcsTestPortion.acsTestPortion.IconClass,
      showTitle: true,
    }

  }

  autoSaveSubject: Subject<void> = new Subject<void>();
  isSaving = false;
  saveQueuedWhileSaving = false;

  autoSave = true;
  showAutoSaveMessage = false;
  autoSaveMessage = 'Auto saving...';
  autoSaveIcon = 'fa fa-spinner fa-spin';

  ngOnInit(): void {
    this.setupReadOnlySubscription();
    this.loadReferenceData();
    this.setupDataWatch();

    if (!this.isReadOnly()) {
      this.setupAutoSave();
    }
  } 

  setupAutoSave() {
    this.subscriptions.push(
    this.autoSaveSubject
      .pipe(debounceTime(2000))
    .subscribe(() => {
      this.tryAutoSave();
    }));
  }
 
  tryAutoSave() {
    if (this.isReadOnly()) {
      return;
    }

    this.showAutoSaveMessage = true;
    this.autoSaveMessage = 'Auto saving...';

    this.saveCurrent(true);

  }

  completeAutoSave() {
    this.autoSaveIcon = 'fa fa-check-circle dw-green';
    this.autoSaveMessage = 'Auto save complete';

    setTimeout(() => {
      this.showAutoSaveMessage = false;
      this.autoSaveIcon = 'fa fa-spinner fa-spin';
    }, 2000);
  }

  gotoAcsPortion(acsPortion: number) {

  }

  

  resultChange(result: PlanOfActionQuestionResultEntity) {
    if (this.isReadOnly()) {
      return;
    }

    if (!result.PlanOfActionResultId) {
      result.PlanOfActionResultId = this.planOfAction.PlanOfActionResultId;
    }
    const existingResult = this.planOfActionQuestionResults.find(x => x.PlanOfActionSectionQuestionId == result.PlanOfActionSectionQuestionId);

    if (existingResult) {
      result.PlanOfActionQuestionResultId = existingResult.PlanOfActionQuestionResultId;
    }

    this.resultsToSaveMap[result.PlanOfActionSectionQuestionId] = result;

    console.log('Result changed', result, this.resultsToSaveMap);

    const resultArray: PlanOfActionQuestionResultEntity[] = [];

    for (const key in this.resultsToSaveMap) {
      if (this.resultsToSaveMap.hasOwnProperty(key)) {
        resultArray.push(this.resultsToSaveMap[key]);
      }
    }

    this.resultsToSave = resultArray;

    this.autoSaveSubject.next();
  }

  goToSection() {
    if (!this.selectedSectionId) {
      return;
    }

    this.sectionIndex = this.currentTestSections.findIndex(x => x.PlanOfActionSectionId == this.selectedSectionId);

    this.setupSection();
  }

  saveCurrent(isAutoSave: boolean = false) {
    if (this.isReadOnly()) {
      return;
    }

    if (this.isSaving) {
      this.saveQueuedWhileSaving = true;
      return;
    }

    if (this.resultsToSave.length == 0) {
      this.finishSave(isAutoSave);
      return;
    }

    this.isSaving = true;

    // Controls keep editing their result objects while the request is in flight.
    const currentSaveResults = this.resultsToSave.map(result => ({ ...result }));
    const currentSaveResultsMap = { ...this.resultsToSaveMap };

    this.resultsToSave = [];
    this.resultsToSaveMap = {};

    this.updateCurrentSaveResults(currentSaveResults, currentSaveResultsMap);

    this.planOfActionRepositoryService.savePlanOfActionQuestionResults(currentSaveResults)
      .pipe(take(1))
      .subscribe(results => {
        
        for (var result of results) {
          const existingResult = this.planOfActionQuestionResults.find(x => x.PlanOfActionSectionQuestionId == result.PlanOfActionSectionQuestionId);

          if (existingResult) {
            // Preserve control bindings and any edits made after this save began.
            const pendingResult = this.resultsToSaveMap[result.PlanOfActionSectionQuestionId];
            Object.assign(existingResult, result, { ...pendingResult });
            existingResult.PlanOfActionQuestionResultId = result.PlanOfActionQuestionResultId;
          } else {
            this.planOfActionQuestionResults.push(result);
          }
        }

        this.isSaving = false;
        this.buildAcsTestDetails();
        
        if (this.saveQueuedWhileSaving || this.resultsToSave.length > 0) {
          this.saveQueuedWhileSaving = false;    
          this.saveCurrent(isAutoSave);
          return;       
        }

        this.finishSave(isAutoSave);
      }, () => {
        // Restore failed edits without overwriting newer changes to the same question.
        this.resultsToSaveMap = { ...currentSaveResultsMap, ...this.resultsToSaveMap };
        this.resultsToSave = Object.keys(this.resultsToSaveMap).map(key => this.resultsToSaveMap[key]);
        this.isSaving = false;
        this.saveQueuedWhileSaving = false;
        this.returnAfterSave = false;
        this.showAutoSaveMessage = false;
        this.formApi.setFormMessage({
          messageBody: 'Question results could not be saved. Your changes are still pending. Please try Save and Return again.',
          severity: DwMessageSeverity.error
        });
      });
  }

  private finishSave(isAutoSave: boolean) {
    this.buildAcsTestDetails();
    if (this.returnAfterSave) {
      this.returnAfterSave = false;
      this.currentAcsTestPortion = null;
      this.updateVariables();
      this.formApi.patchVariableContext<PlanOfActionExecuteVariables>({ ShowPlan: false });
    }
    if (isAutoSave) {
      this.completeAutoSave();
    }
  }
  
  private updateCurrentSaveResults(currentSaveResults: PlanOfActionQuestionResultEntity[], currentSaveResultsMap: { [prop: number]: PlanOfActionQuestionResultEntity; }) {
    for (const result of currentSaveResults) {
      if (!result.PlanOfActionQuestionResultId) {
        const existingResult = this.planOfActionQuestionResults.find(x => x.PlanOfActionSectionQuestionId == result.PlanOfActionSectionQuestionId);

        if (existingResult) {
          result.PlanOfActionQuestionResultId = existingResult.PlanOfActionQuestionResultId;
        }

        currentSaveResultsMap[result.PlanOfActionSectionQuestionId] = result;
      }
    }
  }

  loadReferenceData() {
    this.planOfActionRepositoryService.getAcsTestPortions()
      .subscribe(acsTestPortions => {
        this.acsTestPortions = acsTestPortions;

        this.buildAcsTestDetails();
      });

    this.planOfActionRepositoryService.getPlanOfActionSectionTypes()
      .subscribe(sectionTypes => {
        this.sectionTypes = sectionTypes;
        this.buildAcsTestDetails();
      });
  }

  setupDataWatch() {
    this.formApi.getFormDataChanges(100)
      .subscribe(dataChange => {
        if (this.formApi.isDataLoadComplete) {
          this.checkForDataChange();
        }
      });

    if (this.formApi.isDataLoadComplete) {
      this.checkForDataChange();
    }
  }


  buildAcsTestDetails() {
    if (!this.planOfAction || !this.acsTestPortions || !this.planOfActionSections || !this.planOfActionQuestionResults) {
      return;
    }

    this.acsTestDetails = this.planOfActionUtilService.buildAcsTestDetails(this.planOfAction, this.planOfActionSections, this.planOfActionQuestionResults, this.acsTestPortions);
    if (this.currentAcsTestPortion) {
      this.currentAcsTestPortion = this.acsTestDetails.find(detail =>
        detail.acsTestPortion.AcsTestPortionId === this.currentAcsTestPortion.acsTestPortion.AcsTestPortionId);
    }

    if (this.acsTestDetails.length ==0) {
      this.formApi.setFormMessage({ messageBody: 'No Sections have been created.  Return to edit and add sections & qestions.', severity: DwMessageSeverity.error });
    }
  }

  initComplete = false;

  private checkForDataChange() {
    this.planOfAction = this.formApi.getFormData<PlanOfActionEntity>();

    this.acsCodeStatuses = this.planOfActionRepositoryService.getAcsCodeStatus(this.planOfAction);

    if (this.initComplete) {
      return;
    }

    this.initComplete = true;

    if (!this.planOfAction.PlanOfActionResultId) {
      if (this.isReadOnly()) {
        this.planOfActionQuestionResults = [];
        this.buildAcsTestDetails();
      } else {
        this.planOfActionRepositoryService.createPlanOfActionResult(this.planOfAction)
          .subscribe(planOfAction => {
            this.planOfAction = planOfAction;

            this.formApi.setFormData(planOfAction);

            this.loadPlanOfActionQuestionResults();
          });
      }
    } else {
      this.loadPlanOfActionQuestionResults();
    }

    this.loadPlanOfActionSections();
  }

  private loadPlanOfActionSections() {
    this.planOfActionRepositoryService.loadPlanOfActionSections(this.planOfAction.PlanOfActionId)
      .subscribe(planOfActionSections => {
        this.planOfActionSections = planOfActionSections;

        this.buildAcsTestDetails();

        this.setupPrint();
      });
  }

  private setupPrint() {

    if (this.formApi.formMode == DwFormContextMode.print) {
      this.inPrintMode = true;

      const printPortions = PlanOfActionExecuteComponent.printCurrentAcsTestPortions;

      const printTestDetails = this.acsTestDetails.filter(x => printPortions == null || printPortions.find(acsTestPortionId => acsTestPortionId == x.acsTestPortion.AcsTestPortionId));

      this.printTestDetails = printTestDetails;

      // this.printSections = this.acsTestDetails.filter(x => printPortions == null || printPortions.find(acsTestPortionId => acsTestPortionId == x.acsTestPortion.AcsTestPortionId));



      // this.goToAcsTestPortion(this.printSections[0]);

    }



  }


  private setupSectionList() {
    const sections = this.currentTestSections.map(x => {
      return {
        Id: x.PlanOfActionSectionId.toString(),
        Display: this.getSectionDisplay(x)
      };
    })

    this.sectionList = sections;
  }

  private getSectionDisplay(planOfActionSection: PlanOfActionSectionEntity): any {
    switch (planOfActionSection.PlanOfActionSectionTypeId) {
      case PlanOfActionSectionTypeAllItems.AreaOfOperation:
        return `${planOfActionSection.AcsAreaOfOperationIdDisplay}`;

      case PlanOfActionSectionTypeAllItems.Task:
        return `${planOfActionSection.AcsAreaOfOperationIdDisplay} - ${planOfActionSection.AcsAreaOfOperationTaskIdDisplay}`;

      default:
        return planOfActionSection.SectionName;
    }
  }

  private loadPlanOfActionQuestionResults() {
    if (!this.planOfAction.PlanOfActionResultId) {
      return;
    }

    this.planOfActionRepositoryService.loadPlanOfActionQuestionResults(this.planOfAction.PlanOfActionResultId)
      .subscribe(planOfActionQuestionResults => {
        this.planOfActionQuestionResults = planOfActionQuestionResults;

        this.planOfActionUtilService.setLastQuestionResults(this.planOfActionQuestionResults);
        this.buildAcsTestDetails();
      });
  }

  setupCurrentSection() {
    if (!this.currentTestSections) {
      return;
    }

    this.sectionIndex = 0;

    this.setupSection();

    this.currentSection = this.currentTestSections[this.sectionIndex];
  }

  nextSection() {
    this.sectionIndex++;

    if (this.sectionIndex >= this.currentTestSections.length) {
      this.sectionIndex = this.currentTestSections.length - 1;
    }

    this.setupSection();
  }

  previousSection() {
    this.sectionIndex--;

    if (this.sectionIndex < 0) {
      this.sectionIndex = 0;
    }

    this.setupSection();
  }

  complete() {

    // this.formApi.patchFormData({ PlanOfActionStatusId: PlanOfActionStatusAllItems.Complete})

    this.stop();

    
  }

  stop() {
    this.returnAfterSave = true;
    if (this.isReadOnly()) {
      this.finishSave(false);
    } else {
      this.saveCurrent();
    }
  }

  setupSection() {
    if (!this.isReadOnly()) {
      this.saveCurrent();
    }

    this.currentSection = this.currentTestSections[this.sectionIndex];

    this.hasPrevious = this.sectionIndex > 0;
    this.hasNext = this.sectionIndex < this.currentTestSections.length - 1;
  }

  sectionReadOnlyChanged(readOnly: boolean): void {
  }

  isReadOnly(): boolean {
    return this.isSectionReadOnly();
  }

}
